export const GET_ORDERS = "GET_ORDERS";
export const GET_CERTIFIED_ORDERS = "GET_CERTIFIED_ORDERS";
export const IS_LOADING = "IS_LOADING";
